<template>
	<section>
		<template v-if="isError">
			<header />
		</template>
		<app-snackbar
			:color="snackbar.color"
			:timeout="5000"
			top
			right
			:is-visible="snackbar.isVisible"
		>
			{{ snackbar.text }}
			<button
				class="btn-snackbar"
				type="type"
				@click="snackbar.isVisible = false"
			>
				Cerrar
			</button>
		</app-snackbar>
		<template v-if="isLogin">
			<router-view></router-view>
		</template>
		<template v-else-if="isProductAdmin">
			<router-view></router-view>
		</template>
		<template v-else>
			<navbar :company-data="company"/>
			<router-view></router-view>
			<app-contact :company-data="company" />
			<app-footer :company-data="company" />
		</template>

		<div>
			<div>
				<transition name="modal">
					<div v-if="open">
						<div class="overlay" @click.self="open = false;"> 
							<video-background @click.self="OpenTarget" v-if="company.linkUrl.video"
									:src="company.linkUrl.video"
									class="modalVideo"
								>
								<div class="modalWrap"></div>
								<div :class="(company.linkUrl.title)?'frameText':'frameTextClear'" class="frameText" >
									<div class="frameTitle"  v-if="company.linkUrl.title">{{company.linkUrl.title}}</div>
									<div class="frameSubTitle"  v-if="company.linkUrl.subTitle">{{company.linkUrl.subTitle}}</div>
									<div class="buttonAction" v-if="company.linkUrl.action">
										<a :href="company.linkUrl.url" :target="company.linkUrl.target">
											{{company.linkUrl.action}}
										</a>
									</div>
								</div>
							</video-background>
							<div @click.self="OpenTarget" class="modal" v-if="!company.linkUrl.video && company.linkUrl.image"  :style="`background-image: url(${company.linkUrl.image}); background-size:cover`" >
								<div @click.self="open = false;" v-if="false" class="frameClose">x</div>
								<div :class="(company.linkUrl.title)?'frameText':'frameTextClear'" >
									<div class="frameTitle"  v-if="company.linkUrl.title">{{company.linkUrl.title}}</div>
									<div class="frameSubTitle"  v-if="company.linkUrl.subTitle">{{company.linkUrl.subTitle}}</div>
									<div class="buttonAction" v-if="company.linkUrl.action">
										<a :href="company.linkUrl.url" :target="company.linkUrl.target">
											{{company.linkUrl.action}}
										</a>
									</div>
								</div>							
							</div>
						</div>
					</div>
				</transition>

			</div>
		</div>		
	</section>
</template>

<script>
import appContact from '@/components/commons/app-contact';
import appFooter from '@/components/commons/app-footer';
import appSnackbar from '@/components/commons/app-snackbar';
import navbar from '@/components/commons/navbar';

function OpenTarget()
{
	if (this.company.linkUrl.action=='')
	{
		window.open(this.company.linkUrl.url, `${this.company.linkUrl.target}`).focus();
	}
}


async function mounted() {
	this.$bus.$on('showSnackBar', (snackbar) => {
		const newSnackbar = Object.assign({}, snackbar);
		newSnackbar.isVisible = true;
		this.snackbar = newSnackbar;
	});

	// this.$bus.$on('get-company', (company) => {
	// 	this.company = company;
	// });


	const { data: company } = await this.$http.get(`company/${process.env.COMPANY_CODE}/app/${process.env.APP_CODE}`);
	const newCompany = { ...company.data };
	newCompany.latitude = Number(company.data.latitude);
	newCompany.longitude = Number(company.data.longitude);
	this.company = { ...newCompany };


	const dataPopup = JSON.parse(this.company.imageFooter)
	this.company.linkUrl = dataPopup;
	console.log('data', this.company.linkUrl)
	var fecha = this.company.linkUrl.dateEnd;
	if (fecha!==''){
		var dateEnd = Date.parse(fecha);
		var tempToday = new Date().toISOString();
		var dateToday = Date.parse(tempToday);

		if (dateEnd<dateToday)
		{
			console.log('not today')
		} else
		{
			console.log('open')
			this.open=true;
		}
	}
}

function isLogin() {
	return this.$route.name === 'page-admin' || this.$route.name === 'page-admin-company';
}

function isError() {
	return this.$route.name === 'page-error';
}

function isProductAdmin() {
	const list = this.$route.name === 'products-list';
	const newProduct = this.$route.name === 'products-new';
	return list || newProduct;
}

function data() {
	return {
		company: {},
		open: false,
	};
}

export default {
	name: 'app',
	components: {
		appContact,
		appFooter,
		appSnackbar,
		navbar,
	},
	computed: {
		isLogin,
		isProductAdmin,
		isError,
	},
	data,
	mounted,
	metaInfo() {
		const { company } = this.$store.state;
		var seo = company.helpers;
		var metas = seo.meta.concat(seo.og);
        return { 
            title: seo.title,
            meta: metas
        }
    }	
};
</script>

<style lang="scss">

	*	{
		box-sizing: border-box;
		-webkit-font-smoothing: antialiased;
	}

	.slider-container {
		white-space: inherit !important;
	}

	.container-section-history {
		.active_tab {
			border: none !important;
			border-bottom: 3px solid map-get($colors, red-dark) !important;
			font-family: map-get($fonts, maison-bold) !important;
			font-size: 11px;
		}

		.tabs__link {
			color: map-get($colors, black-dark) !important;
			font-family: map-get($fonts, maison-light);
			font-size: 11px;
		}

		.vue-tabs .nav-tabs {
			border-bottom: 1px solid map-get($colors, black-dark) !important;
		}

		.vue-tabs .nav-tabs > li {
    	margin-bottom: -2px !important;
		}

		.nav-tabs {
			display: flex;
    	justify-content: space-between;
		}

		.tab {
			width: 10%;
		}
	}	

	.container-section-history {
		.active_tab {
			border: none !important;
			border-bottom: 3px solid map-get($colors, red-dark) !important;
			font-family: map-get($fonts, maison-bold) !important;
			font-size: 11px;
		}

		.tabs__link {
			color: map-get($colors, black-dark) !important;
			font-family: map-get($fonts, maison-light);
			font-size: 10px;
		}

		.vue-tabs .nav-tabs {
			border-bottom: 1px solid map-get($colors, black-dark) !important;
		}

		.vue-tabs .nav-tabs > li {
    	margin-bottom: -2px !important;
		}

		.nav-tabs {
			display: flex;
    	justify-content: space-between;
		}

		.tab {
			width: 10%;
		}

		@media (min-width: 1029px) {
			.tabs__link {
			@include font-size(13);
			}

			.vue-tabs {
				padding: 10px 134px;
			}

			.tab {
				width: 52px;
			}

			.tabs__link:hover {
				background: none !important;
				border-left: none;
				border-right: none;
				border-top: none;
			}
		}
	}	

	.container-section-us {
		.nav-tabs-wrapper {
			margin-top: 25px;
		}

		.active_tab {
			border: none !important;
			border-bottom: 3px solid map-get($colors, red-dark) !important;
			font-family: map-get($fonts, maison-bold) !important;
			font-size: 11px;
		}

		.tabs__link {
			color: map-get($colors, black-dark) !important;
			font-family: map-get($fonts, maison-light);
			font-size: 11px;
		}

		.vue-tabs .nav-tabs {
			border-bottom: 1px solid map-get($colors, black-dark) !important;
		}

		.vue-tabs .nav-tabs > li {
    	margin-bottom: -2px !important;
		}

		.nav-tabs {
			display: flex;
    		justify-content: space-between;
		}

		.vue-tabs .nav-tabs > li > a {
			padding: 2px 0px;
		}

		@media (min-width: 1266px) {
			.nav-tabs-wrapper {
				margin-top: 0px !important;
			}
			
			.nav-tabs-navigation {
				width: 441px;
			}

			.tabs__link {
				@include font-size(13);
			}

			.vue-tabs {
				position: relative;
			}

			.nav-tabs-navigation {
				position: absolute;
				top: 50px;
			}

			.tabs__link:hover {
				background: none !important;
				border-left: none;
				border-right: none;
				border-top: none;
			}
		}
	}

	.home-business {
		.swiper-button-next {
			@include transition(transform .3s linear 0s);
			background-image: url('http://picture-controlinn.s3.amazonaws.com/svg/path-2.svg') !important;
			background-size: cover;
			outline: none;

			&:hover {
				@include transform(scale(1.5));
			}
		}

		.swiper-button-prev {
			@include transition(transform .3s linear 0s);
			background-image: url('http://picture-controlinn.s3.amazonaws.com/svg/arrow-left-proquiandinos.svg') !important;
			background-size: cover;
			outline: none;

			&:hover {
				@include transform(scale(1.5));
			}
		}

		.swiper-slide {
			width: 280px !important;
		}

		@media (max-width: 968px) {
			.swiper-slide {
				width: 100% !important;

				.slider {
					margin-right: 0px;
				}
			}

			.swiper-button-next {
				height: 24px;
				right: -21px;
				width: 13px;
			}

			.swiper-button-prev {
				height: 24px;
				left: -21px;
				width: 13px;
			}
		}
			
		@media (max-width: 1292px) and (min-width:968px){
			.swiper-slide {
				width: 268px !important;
			}

			.swiper-button-next {
				height: 26px;
				right: -30px;
				width: 14px;
			}

			.swiper-button-prev {
				height: 26px;
				left: -45px;
				width: 14px;
			}
		}
			
		@media (min-width: 1292px) {
			.swiper-slide {
				width: 280px !important;
			}

			.swiper-button-next {
				height: 26px;
				right: -30px;
				width: 14px;
			}

			.swiper-button-prev {
				height: 26px;
				left: -45px;
				width: 14px;
			}
		}
	}

	.odometer-inside {
		margin-left: 35px !important;
		margin-right: 10px !important;
	}

	.vue-map-container {
		height: 554px !important;
	}

	.detail-product {
		.active_tab {
			background: map-get($colors, background-products) !important;
			border: none !important;
			border-bottom: 3px solid map-get($colors, red-dark) !important;
			font-family: map-get($fonts, maison-bold) !important;
			font-size: 11px;
		}

		.tabs__link {
			color: map-get($colors, black-dark) !important;
			font-family: map-get($fonts, maison-light);
			font-size: 13px;
		}

		.vue-tabs .nav-tabs {
			border-bottom: 1px solid map-get($colors, black-dark) !important;
		}

		.vue-tabs .nav-tabs > li {
    	margin-bottom: -2px !important;
		}

		.nav-tabs {
			display: flex;
    	justify-content: space-between;
		}

		.vue-tabs .nav-tabs > li > a {
			padding: 2px 0px;
		}

		@media (min-width: 1024px) { 
			.nav-tabs-wrapper {
				width: 340px;
			}

			.vue-tabs {	
    		margin: auto;
				width: 1000px;
			}
			
			.tabs__link:hover {
				background: none !important;
				border-left: none;
				border-right: none;
				border-top: none;
			}
		}
	}

	.btn-snackbar {
		color: map-get($colors, white);
		font-family: map-get($fonts, lato-bold);
		margin-left: 55px;
		padding: 5px;
		text-transform: uppercase;
	}

	.main-title {
		font-family: map-get($fonts, maison-bold) !important;
		font-size: map-get($sizes, large) !important;
	}




/* MODAL */
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
	.modal, .modalVideo {
		width: 90% !important;		
	}

	.frameVideo
	{
		width: 90% !important;
	}

	.frameText {
    	width: 45% !important;
	}
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
	.modal, .modalVideo {
		width: 90% !important;
	}

	.frameVideo
	{
		width: 90% !important;
	}

	.frameText {
    	width: 60% !important;
	}
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
	.modal, .modalVideo {
		width: 90% !important;
	}

	.frameVideo
	{
		width: 90% !important;
	}

	.frameText {
    	width: 45% !important;
	}
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
	.modal, .modalVideo {
		width: 40% !important;
	}

	.frameVideo
	{
		width: 40% !important;
	}
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
	.modal, .modalVideo {
		width: 50% !important;
	}

	.frameVideo
	{
		width: 50% !important;
	}
}

.modal {
    margin: 0 auto;
    padding: 20px;
    background-color: #3e3e3e;
    border-radius: 2px;
    box-shadow: 0 2px 8px 3px;
    transition: all .2s ease-in;
    font-family: Helvetica,Arial,sans-serif;
    height: 600px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
	cursor: pointer;
}

.modalWrap{
	height: 350px;
}

.modalVideo
{
    margin: 0 auto;
    padding: 0px;
    background-color: #3e3e3e;
    border-radius: 2px;
	box-shadow: 0 2px 8px 3px #3e3e3e !important;
    transition: all .2s ease-in;
    font-family: Helvetica,Arial,sans-serif;
    height: 600px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
	cursor: pointer;
}


.frameVideo
{
	height: 600px;
}


.fadeIn-enter {
  opacity: 0;
}

.fadeIn-leave-active {
  opacity: 0;
  transition: all 0.2s step-end;
}

.fadeIn-enter .modal,
.fadeIn-leave-active.modal {
  transform: scale(1.1);
}

button {
  padding: 7px;
  margin-top: 10px;
  background-color: green;
  color: white;
  font-size: 1.1rem;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #00000094;
  z-index: 999;
  transition: opacity 0.2s ease;
}

.modalTitle
{
	display: flex;
	justify-content: center;
	align-items: center;
	color: #fff;
	font-size: 28px; 	
	padding: 10px;
}

.modalSubtitle
{
	display: flex;
	justify-content: center;
	align-items: center;
	color: #fff;
	font-size: 16px; 
	padding: 5px;
}


.embed-responsive-item
{
	width: 100% !important;
	height: 400px !important;
}

.btn-modalModal
{
	@include font-maison-bold();
	@include font-size(14);
	@include transform(translateX(-50%));
	background: map-get($colors, base);
	color: map-get($colors, white);
	left: 50%;
	margin-top: 31px;
	padding: 13px 35px;
	position: relative;
	margin-top: 415px !important;
}

.frameText
{
   	background-color: hsla(0,0%,100%,.5);
    float: right;
    width: 45%;
    min-height: inherit;
    padding: 5px;
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: flex-end;
    margin: 0;
    -ms-flex-direction: column;
    flex-direction: column;
    bottom: 1.5em;
    right: 1.5em;
}

.frameTextClear
{
   	background-color: transparent;
    float: right;
    width: 45%;
    min-height: inherit;
    padding: 5px;
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: flex-end;
    margin: 0;
    -ms-flex-direction: column;
    flex-direction: column;
    bottom: 1.5em;
    right: 1.5em;
}

.buttonAction
{
    background-color: #001d32;
    color: #fff;
    min-width: 90%;
    margin: 4em auto 1em auto;
    padding: 12px;
    text-align: center;
    bottom: 10px;
	border-radius: 0.2em;
}

.frameTitle
{
	padding: 10px;
	color: #000;
	font-size:1.5em;
	font-weight: 600;
	letter-spacing:0;
	line-height:1.2em;
	width:100%;
	word-break: break-word;
}

.frameSubTitle
{
	padding: 10px;
	color: #000;
	font-size: 18px;
	letter-spacing:0;
	line-height:1.2em;
	width:100%;
	bottom: 80px;
	word-break: break-word;
}

.frameClose
{
	background-color: #f5222d;
    color: #fff;
    border-radius: 50px;
    width: 21px;
    height: 21px;
    text-align: center;
    margin-top: -30px;
    margin-right: -30px;
    align-self: flex-start;
    position: absolute;
}



</style>




// WEBPACK FOOTER //
// src/App.vue